import * as React from "react";
import type { SVGProps } from "react";
const SvgLibraryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M7.158 2C5.42 2 4 3.408 4 5.13v17.958C4 24.745 5.49 26 7.158 26H24v-1.044H7.158c-1.137 0-2.105-.845-2.105-1.868S6 21.304 7.158 21.304H24V2zm0 1.043h15.79v17.218H7.157c-.785 0-1.53.281-2.105.74V5.13a2.09 2.09 0 0 1 2.105-2.088m1.579 2.61c-.576 0-1.053.472-1.053 1.043v2.087c0 .57.477 1.043 1.053 1.043H19.79c.575 0 1.052-.473 1.052-1.043V6.696c0-.571-.477-1.044-1.052-1.044zm0 1.043H19.79v2.087H8.737z"
    />
  </svg>
);
export default SvgLibraryIcon;
